export default {
    getProperties: (state) => {
        return state.properties;
    },
};
